import React from "react";

const FAQ = () => {
  return (
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb-no-gutter">
          <li class="breadcrumb-item">
            <a class="breadcrumb-link" href="javascript:;">
              Page d'acceuil
            </a>
          </li>
          <li
            class="breadcrumb-item active"
            style={{ color: "rgb(255, 77, 7)" }}
            aria-current="page"
          >
            FAQ
          </li>
        </ol>
      </nav>
      <div className="row justify-content-lg-center">
        <div class="col-xl-12">
          {" "}
          <div class="row justify-content-center">
            {" "}
            <div class="col-xl-6">
              {" "}
              <div class="text-center p-3 faq-header mb-4">
                {" "}
                <h4 class="mb-1 fw-semibold">Frequently Asked Questions</h4>{" "}
                <p class="fs-15 text-muted op-7">
                  We have shared some of the most frequently asked questions to
                  help you out!{" "}
                </p>
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>
        <div className="col-8">
          <div className="card">
            <div className="card-body">
              <div className="section-title mb-0 mt-4 mt-lg-0">
                <h6 className="sub-title">SOME FAQ'S</h6>
                <h5 className="title">
                  Lorem <span> Dighetr </span> Loipsum.
                </h5>
                <p className="content">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Nihil, deleniti.
                </p>
              </div>
              <div
                className="accordion accordion-inner style-2 accordion-icon-left mt-3"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Comment faire une déclaration ?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Many desktop publishing packages and web page editors now
                      use Lorem Ipsum as their default model text, search for
                      'lorem ipsum' will uncover
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Comment accéder à vos documents ?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Many desktop publishing packages and web page editors now
                      use Lorem Ipsum as their default model text, search for
                      'lorem ipsum' will uncover
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Comment changer votre mot de passe ?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Many desktop publishing packages and web page editors now
                      use Lorem Ipsum as their default model text, search for
                      'lorem ipsum' will uncover
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
